export default function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/jbrandt/Documents/projects/electrifiedwomen/src/theme/electrifiedwomen/node_modules/swiper/core/events/onClick.js
// module id = 80
// module chunks = 0